// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"287":"26c8f261509e5cdf","634":"f3c671cbc164e26d","838":"75700a05bb7b23ef","917":"cfb5280eb5437b98"}[chunkId] + ".js";
};